<script lang="ts">
    import {getModalContext} from './modal-context';
    import {getLocalization} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let defaultClose = true;

    const context = getModalContext();
    const localize = getLocalization();
    const dispatch = createEventDispatcher<{ 'close': void }>();

    const handleCloseClick = () => {
        if (defaultClose) {
            context.modalWindowActions.cancel();
            return;
        }

        dispatch('close');
    }
</script>

<button type="button"
        class="kp-modal-close-button"
        title="{localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}"
        aria-label="{localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}"
        on:click={handleCloseClick}>
    <UIcon icon="cross-circle"/>
</button>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-modal-close-button {
        grid-area: modal-close-button; // to place it to the right side of the heading regardless of the DOM placement
        align-self: start; // top
        justify-self: end; // right

        display: flex; // to fix inline icon placement
        padding: 0;
        border: 0;
        background: transparent;
        appearance: none;

        font-size: (@font-size-base * 1.5);
        font-weight: @close-font-weight;
        line-height: 1;
        color: @close-color;
        text-shadow: @close-text-shadow;
        opacity: 0.2;

        &:hover,
        &:focus {
            opacity: 0.5;
        }
    }
</style>